import SummaryPanel from "../SummaryPanel";
import EntitiesPanel from "../EntitiesPanel";
import ActionItemsPanel from "../ActionItemsPanel";

export default function AnalysisTab(props: {
  summary: string;
  insights: any;
  loading: boolean;
  error: string;
  actionItems: any[];
  onToggleAction: (id: string) => void;
  onRegenerate?: () => void;
}) {
  return (
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="md:col-span-2">
        <SummaryPanel
          text={props.summary}
          loading={props.loading}
          error={props.error}
          onRegenerate={props.onRegenerate}
        />
      </div>
      <EntitiesPanel
        info={props.insights}
        loading={props.loading}
        error={props.error}
        onToggle={props.onToggleAction}
      />
      <ActionItemsPanel
        items={props.actionItems}
        onToggle={props.onToggleAction}
      />
    </div>
  );
}
